import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-[var(--radius-card)] bg-surface p-5 shadow-[var(--shadow-card)]',
        className,
      )}
      {...props}
    />
  );
}
